<template>
  <vs-sidebar
    data-tour-step="4"
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ $t("advancedSearch") }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div class="mt-5 mb-5">
          <label class="input-label font-bold" ref="govLabel">إلي المدينة</label>
          <SelectInputVue
            :options="resultGovs"
            v-model="advancedSearchObj.toGovId"
          >
            <template #search>
              <input
                @blur.stop
                class="inner-input"
                v-model="search"
                @input="searchAll(1)"
                placeholder="إبحث هنا"
              />
            </template>
          </SelectInputVue>
        </div>
        
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6 justify-end" slot="footer">
      <button
        class="mr-6 send-order"
        :class="{ 'opacity-btn1': !isFormValid }"
        @click="
          googleEventTrack(
            'الضغط على زر البحث داخل البحث المتقدم',
            'navbar',
            'advanced_search_sidebar'
          ),
            submitData()
        "
        :disabled="!isFormValid"
        style="font-family: Cairo"
      >
        بحث
      </button>
      <button class="cancel-btn" @click="initValues()">اعادة تعيين</button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapActions, mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import allStatus from "@/views/status/orderStatus";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import $ from "jquery";
import landLine from "@/mixins/landLine.js";
import removeSpaceNumber from "@/mixins/removeSpaceNumber.js";
import gTag from "@/mixins/gtag.js";
import validationPhone from "@/mixins/validationPhone.js";
import SelectInputVue from "@/layouts/components/SelectInput.vue";

export default {
  name: "add-advanced-search",
  mixins: [landLine, removeSpaceNumber, gTag, validationPhone],
  props: {
    isSidebarActive: {
      type: Boolean,
    },
    statusForAdvancedSearch: {
      type: Number,
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
    SpinnerColor,
    SelectInputVue,
  },
  data() {
    return {
      resultGovs: [],
      search: "",
      searchCaptain: "",
      searchBranch: "",
      allStatusPages: allStatus,
      advancedSearchObj: {
       
        toGovId: "",
        govName: "",

      },
      loading: false,

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    ...mapGetters("dataList", ["governments"]),
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      if (
        !this.errors.any() &&
        (
          this.advancedSearchObj.toGovId != ""
   )
      ) {
        return true;
      } else {
        return false;
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    ...mapActions("dataList", [
      "advancedSearch",
      "fetchGovData",
    ]),
    openOptions(nameOfRef) {
      let el = this.$refs[nameOfRef];
      $(el).slideToggle();
    },
    resultOptions(ref1, ref2) {
      let el1 = this.$refs[ref1];
      let el2 = this.$refs[ref2];
      $(el1).css("opacity", 1);
      $(el2).slideUp();
    },
    async searchAll(type) {
      this.loading = true;
      if (type == 1) {
        if (this.search == "") {
          this.resultGovs = this.governments;
        } else {
          this.resultGovs = this.governments.filter((governments) =>
            governments.name.toLowerCase().includes(this.search.toLowerCase())
          );
        }
      } else if (type == 2) {
        if (this.searchCaptain != "") {
          let obj = {
            page: this.pageForCaptains,
            search: this.searchCaptain,
          };
          await this.getCaptains(obj);
        }
      } else if (type == 3) {
        if (this.searchBranch != "") {
          let obj = {
            page: this.pageForBranches,
            search: this.searchBranch,
          };
          await this.getBranches(obj);
        }
      }
      this.loading = false;
    },
    initValues() {
      Object.keys(this.advancedSearchObj).forEach((key) => {
        this.advancedSearchObj[key] = "";
      });
    },
    submitData() {
      if (this.isFormValid) {
        this.$emit("closeSidebar");
        this.$router
          .push({
            path: "/CostsAdvancedSearch",
            query: { obj: this.advancedSearchObj },
          })
          .catch(() => {});
        this.initValues();
      }
    },
  },
  async created() {
    if (this.governments.length == 0) {
      await this.fetchGovData();
    }
    this.resultGovs = this.governments;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_advancedSearch.scss";
@import "@/assets/scss/vuexy/_editOrder.scss";
</style>
<style lang="scss">
.advanced-date {
  .vdp-datepicker {
    div {
      input {
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3125rem;
        height: 2.4375rem;
        padding: 0 0.75rem;
        margin-bottom: 1.25rem;
        color: rgba(0, 0, 0, 0.7);
        width: 100%;
      }
      input::placeholder {
        color: rgba(0, 0, 0, 0.7) !important;
        opacity: 50%;
        font-size: 0.9rem;
        line-height: 1.3125rem;
        font-family: "cairo";
      }
    }
  }
  label {
    font-size: 0.85rem;
    margin-bottom: 2px;
    color: rgba(0, 0, 0, 0.7);
    line-height: 1.3125rem;
    padding-left: 5px;
    display: block;
  }
}
.vs-con-input {
  input {
    height: 2.4375rem;
  }
}
.input-select {
  position: relative;
  label {
    padding-left: 5px;
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.6);
  }
  input {
    cursor: pointer;
    width: 100%;
    border: 0.0625rem solid #d8d6de;
    border-radius: 0.3125rem;
    height: 2.4375rem;
    padding: 0 0.75rem;
    margin-bottom: 1.5rem;
    &::placeholder {
      color: #6e6b7b;
      opacity: 50%;
      font-size: 0.75rem;
      line-height: 1.3125rem;
    }
  }
  svg {
    position: absolute;
    top: 35px;
    right: 12px;
  }
  .select-options {
    display: none;
    max-height: 260px;
    overflow: auto;
    border: 1px solid #eee;
    padding: 4px;
    padding-top: 6px;
    padding-bottom: 6px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);
    transform: translateY(-20px);
    .inner-input {
      cursor: default;
      margin-bottom: 0px;
    }
    li {
      background: transparent;
      padding: 5px;
      width: 100%;
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.search-input {
  .con-select {
    width: 100%;
    .input-select-con {
      input {
        width: 100%;
        border: 0.0625rem solid #d8d6de;
        border-radius: 0.3125rem;
        height: 2.4375rem;
        padding: 0 0.75rem;
        margin-bottom: 1.5rem;
      }
      input::placeholder {
        color: #6e6b7b;
        opacity: 50%;
        font-size: 0.75rem;
        line-height: 1.3125rem;
        font-family: "cairo";
      }
      .vs-select--icon {
        top: 33%;
      }
    }
  }
}
.vs-select--options {
  z-index: 9999999999;
  right: 21.6px;
  input {
    font-family: "cairo";
    color: #6e6b7b;
    width: 100%;
    border: 0.0625rem solid #d8d6de;
    border-radius: 0.3125rem;
    height: 2.4375rem;
    padding: 0 0.75rem;
    margin-bottom: 0.625rem;
  }
  input::placeholder {
    color: #6e6b7b;
    opacity: 50%;
    font-size: 0.75rem;
    line-height: 1.3125rem;
    font-family: "cairo";
  }
  div {
    li {
      button {
        span {
          font-family: "cairo";
        }
      }
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
